// QRScanner.js
import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { ref, get } from "firebase/database";
import { database } from "./firebase.js";

const QRScanner = () => {
  const [isScanning, setIsScanning] = useState(false);

  useEffect(() => {
    const onScanSuccess = (decodedText, decodedResult) => {
      if (isScanning) return;
      setIsScanning(true);

      // QR içeriğini göster
      document.getElementById('qr-reader-results').innerText = `QR Code Data: ${decodedText}`;

      // TC bilgisini QR'dan ayıkla (örneğin: "TC: 12345678901, Name: Ahmet...")
      const data = decodedText.split(', ');
      const tcValue = data[0].split(': ')[1];
      console.log(`TC Value: ${tcValue}`);

      // Firebase'de TC kontrolü
      checkQRCode(tcValue);

      // 3 saniye sonra tekrar taramaya izin ver
      setTimeout(() => {
        setIsScanning(false);
      }, 3000);
    };

    const onScanFailure = (error) => {
      console.warn(`Code scan error: ${error}`);
    };

    const html5QrcodeScanner = new Html5QrcodeScanner(
      "qr-reader", { fps: 10, qrbox: 250 }
    );
    html5QrcodeScanner.render(onScanSuccess, onScanFailure);

    return () => {
      html5QrcodeScanner.clear();
    };
  }, [isScanning]);

  // 🔍 TC'yi Firebase'de kontrol et
  const checkQRCode = async (tcValue) => {
    const userRef = ref(database, `qr-ticket`);

    try {
      const snapshot = await get(userRef);

      if (snapshot.exists()) {
        let tcExists = false;

        snapshot.forEach((childSnapshot) => {
          const userData = childSnapshot.val();
          if (String(userData.TC) === tcValue) {
            tcExists = true;
          }
        });

        if (tcExists) {
          alert("✅ Onaylandı");
        } else {
          alert("❌ Kayıtlı değil");
        }
      } else {
        alert("📭 Veritabanı boş.");
      }
    } catch (error) {
      console.error("Veritabanı sorgusunda hata:", error);
      alert("⚠️ QR kod kontrolü sırasında hata oluştu.");
    }
  };

  return (
    <div>
      <h1>QR Code Scanner</h1>
      <div id="qr-reader" style={{ width: "300px" }}></div>
      <div id="qr-reader-results"></div>
    </div>
  );
};

export default QRScanner;

